import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { blue } from '@material-ui/core/colors'
import { useForm } from 'react-hook-form'
import cx from 'classnames'
import styles from './TextInput.module.scss'
const useStyles = makeStyles(() => ({
  input: {
    [`& fieldset`]: {
      borderRadius: 30,
      borderColor: 'grey'
    },
    '& label.Mui-focused': {
      color: blue[600]
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'grey'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey'
      },
      '&:hover fieldset': {
        borderColor: 'grey'
      },
      '&.Mui-focused fieldset': {
        borderColor: blue[600]
      }
    }
  }
}))
const TextInput = props => {
  const { labelName, inputProps, handleChange, value, valueName, placeholder, disabled } = props
  const { register, errors } = useForm()
  const classes = useStyles()
  return (
    <TextField
      variant='outlined'
      required
      fullWidth
      id={valueName}
      label={labelName}
      inputProps={inputProps}
      onKeyPress={e => {
        e.key === 'Enter' && e.preventDefault()
      }}
      disabled={disabled}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      inputRef={register({ required: true })}
      name={valueName}
      autoComplete={valueName}
      className={cx(styles.input, classes.input, {
        [styles.hasError]: errors.name
      })}
      InputLabelProps={{
        shrink: value ? true : undefined
      }}
    />
  )
}
export default TextInput
